import React from 'react';

// import styled components
import {
  FooterAbout,
  FooterContainer,
  FooterInfo,
  FooterSocial,
  FooterWrapper,
} from './styled';

// import assets
import ehlIcon from '../../images/footer/ehl-icon.png';
import facebookIcon from '../../images/footer/facebook-icon.png';
import instagramIcon from '../../images/footer/instagram-icon.png';
import linkedInIcon from '../../images/footer/linkedin-icon.png';
import twitterIcon from '../../images/footer/twitter-icon.png';

const Footer = () => {
  return (
    <FooterWrapper>
      <FooterContainer>
        <img src={ehlIcon} alt="Equal Housing Opportunity" />
        <FooterInfo>
          <a
            href="https://onetrusthomeloans.com/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy
          </a>
          <span className="padded">|</span>
          <a
            href="https://onetrusthomeloans.com/licensing-information/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Licensing
          </a>
          <br />
          <br />
          <a
            href="https://www.nmlsconsumeraccess.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            NMLS Consumer Access
          </a>
        </FooterInfo>
        <FooterAbout>
          <p>
            <a
              href="https://onetrusthomeloans.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              OneTrust Home Loans
            </a>
            , a dba of Calcon Mutual
            <br />
            Mortgage LLC, NMLS #46375 (
            <a
              href="http://www.nmlsconsumeraccess.org"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.nmlsconsumeraccess.org
            </a>
            )
          </p>
          <p>
            © 2019 - {new Date().getFullYear()}{' '}
            <a
              href="https://onetrusthomeloans.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              OneTrust Home Loans
            </a>
            <br />
            <br />
            By refinancing your existing loan, your total finance charges may be
            higher over the life of the loan. (Reference:{' '}
            <a
              href="https://law.lis.virginia.gov/admincode/title10/agency5/chapter160/section60/"
              target="_blank"
              rel="noopener noreferrer"
            >
              10 VAC 5-160-60 (F)
            </a>
            )
          </p>
        </FooterAbout>
        <FooterSocial>
          <a
            href="https://www.facebook.com/OneTrustHomeLoans/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={facebookIcon} alt="OneTrust Facebook" />
          </a>
          <a
            href="https://www.linkedin.com/company/onetrust-home-loans"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={linkedInIcon} alt="OneTrust LinkedIn" />
          </a>
          <a
            href="https://www.twitter.com/OneTrustHL"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={twitterIcon} alt="OneTrust Twitter" />
          </a>
          <a
            href="https://www.instagram.com/onetrusthomeloans/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={instagramIcon} alt="OneTrust Instagram" />
          </a>
          <script
            type="text/javascript"
            src="https://www.success-software.biz/adintel/ss_adintel.js"
            defer
          ></script>
        </FooterSocial>
      </FooterContainer>
    </FooterWrapper>
  );
};

export default Footer;
